import { IinstallBase } from '../models';

/**
 * SAP-linked assets within a selection; deleting these requires the
 * DeleteSAPAsset security function (same rule as single delete).
 *
 * @param   {IinstallBase[]} installBases all install bases of the product
 * @param   {string[]} selectedIds ids the user has checked
 *
 * @return  {IinstallBase[]} selected, non-deleted, SAP-linked installs
 */
export const getSelectedSapInstalls = (
    installBases: IinstallBase[],
    selectedIds: string[]
): IinstallBase[] =>
    installBases.filter(
        install =>
            selectedIds.indexOf(install.id) !== -1 &&
            !install.isDeleted &&
            !!install.sapEquipmentNumber
    );
